<template>
  <MasterDetail
    ref="masterDetail"
    :canDelete="false"
    :cols="cols"
    formTitle="Nível hierarquico"
    :hasExportCSV="false"
    :hasExportXLSX="false"
    :opts="opts"
    :resourceUrl="resourceUrl"
    serverPagination
  ></MasterDetail>
</template>

<script>
import MasterDetail from "@/components/master-detail.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    MasterDetail
  },
  data() {
    return {
      opts: {
        tipos: []
      }
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    cols() {
      const selectedItem = this.$refs.masterDetail?.selectedItem || {};
      const { descricao } = this.opts.tipos.find(({ id }) => selectedItem.tipo_id === id) || {};

      return [
        {
          key: "nome",
          name: "Nome",
          type: this.$fieldTypes.TEXT,
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }]
        },
        {
          key: "tipo_id",
          name: "Tipo",
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: { to: "tipos", key: "id", name: "nome" },
          rules: [{ rule: "required" }]
        },
        {
          key: "subtitle",
          name: descricao,
          type: this.$fieldTypes.SUBTITLE,
          hideInTable: true,
          hideInform: !descricao
        }
      ];
    },
    resourceUrl() {
      return `/v1/ativacaoped/${this.clientId}/nivel-hierarquicos`;
    }
  },
  created() {
    if (this.clientId === 0) {
      this.goToHome();
    } else {
      this.getTypes();
    }
  },
  watch: {
    clientId(value) {
      if (value === 0) {
        this.goToHome();
      }
    }
  },
  methods: {
    async getTypes() {
      try {
        const resource = this.apiResource(`v1/ativacaoped/${this.clientId}/nivel-hierarquicos/tipos`);
        const response = await resource.get();
        this.opts.tipos = response;
      } catch (error) {
        this.opts.tipos = [];
        
        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    },
    goToHome() {
      this.notify({
        error:
          "Não é possível acessar o módulo de Ativação P&D sem uma empresa selecionada."
      });
      this.$router.push({ name: "homepage" });
    }
  }
};
</script>
